import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import esTranslation from "./es.json";
import enTranslation from "./en.json";
import { setReportTranslator } from "@dd-report-components/report/i18n";
import reportEsTranslation from "@dd-report-components/report/locales/es.json";
import reportEnTranslation from "@dd-report-components/report/locales/en.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    debug: false,
    resources: {
      es: {
        translation: esTranslation,
      },
      en: {
        translation: enTranslation,
      },
    },
    detection: {
      order: ["navigator"],
      caches: [],
    },
  });

// The shared DD report renderer owns its own labels (admin-interface renders
// the same markup with no i18next at all), so they are merged in here rather
// than duplicated in es.json/en.json. Deep merge, no overwrite: a key these
// locale files do declare still wins.
i18n.addResourceBundle("es", "translation", reportEsTranslation, true, false);
i18n.addResourceBundle("en", "translation", reportEnTranslation, true, false);

// With the bundles in place, i18next is the translator — that is what keeps
// the report language-aware in this app.
setReportTranslator((key, params) => i18n.t(key, params));
